import React from 'react';

import SnapchatIcon from '../icons/SnapchatIcon';
import FacebookIcon from '../icons/FacebookIcon';
import TwitterIcon from '../icons/TwitterIcon';
import InstagramIcon from '../icons/InstagramIcon';
import TiktokIcon from '../icons/TiktokIcon';


function SocialMediaLinks(props) {
  const {
    hasSocialLinks,
    isNakedNewsLive,
    anchor,
  } = props;

  const shouldRenderLinks = hasSocialLinks && !isNakedNewsLive;
  const {
    snapchat,
    facebook,
    twitter,
    tiktok,
    instagram,
  } = anchor || {};

  if (!shouldRenderLinks) {
    return null;
  }

  return (
    <div className="anchor-banner-social">
      <div className="anchor-banner-social-follow">
        Social Media:
      </div>
      <div className="anchor-banner-social-icons">
        {snapchat &&
        <a className="social-links__icon" href={snapchat} rel="noopener noreferrer" target="_blank">
          <SnapchatIcon />
        </a>
        }
        {facebook &&
        <a className="social-links__icon" href={facebook} rel="noreferrer" target="_blank">
          <FacebookIcon />
        </a>
        }
        {twitter &&
        <a className="social-links__icon" href={`http://twitter.com/${twitter}`} rel="noreferrer" target="_blank">
          <TwitterIcon />
        </a>
        }
        {instagram &&
        <a className="social-links__icon" href={`http://instagram.com/${instagram}`} rel="noreferrer" target="_blank">
          <InstagramIcon />
        </a>
        }
        {tiktok &&
        <a className="social-links__icon" href={`http://www.tiktok.com/${tiktok}`} rel="noreferrer" target="_blank">
          <TiktokIcon />
        </a>
        }
      </div>
    </div>
  );
}

export default SocialMediaLinks;
